const SmallStat = ({ bg, text, count, active, handleChange }) => {
  return (
    <div
      title={`Click to view ${text}`}
      className={`${
        active ? "order-2" : "order-1"
      } md:order-none relative w-[95vw] md:w-[310px] lg:w-[354px] h-[120px] md:h-[200px] rounded-[15px] px-4 py-4 md:p-6 cursor-pointer
                  transition-transform duration-300 ease-in-out  hover:shadow-md`}
      onClick={handleChange}
      style={{ backgroundColor: `${bg}20` }} // dynamic bg with ~20% opacity
    >
      {/* Circle with count */}
      <div className="absolute w-[40px] h-[40px] md:w-[97px] md:h-[97px] rounded-full bg-white right-3 top-4 md:right-6 flex items-center justify-center transition-transform duration-300 ease-in-out">
        <p className="text-32pt md:text-48pt text-orange">{count}</p>
      </div>

      {/* Text at bottom */}
      <div className="break-normal absolute w-[40%] h-full md:w-[97px] md:h-[97px] lg:w-[40%] -bottom-10 md:-bottom-3 transition-transform duration-300 ease-in-out">
        <p className="text-32pt leading-none ">{text}</p>
      </div>

      {/* Arrow at bottom center (always mounted, animated in/out) */}
      <div
        className={`md:block z-[10] absolute left-1/2 -translate-x-1/2  -bottom-[30px]  md:-bottom-[48px] 
              w-[40px] h-[32px] md:w-[55px] md:h-[48px] 
              transition-all duration-500 ease-in-out
              ${
                active ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 55 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M27.5 48L0 0H55L27.5 48Z" fill={`${bg}20`} />
        </svg>
      </div>

      <div
        className={`md:block z-[9] absolute left-1/2 -translate-x-1/2 -bottom-[30px]  md:-bottom-[48px] 
              w-[40px] h-[32px] md:w-[55px] md:h-[48px] 
              transition-all duration-500 ease-in-out
              ${
                active ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 55 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M27.5 48L0 0H55L27.5 48Z" fill={`#fff`} />
        </svg>
      </div>
    </div>
  );
};

export default SmallStat;
